// extracted by mini-css-extract-plugin
module.exports = {"clusterMarker":"antd-pro-components-map-markers-cluster-marker-styles-clusterMarker"};